import lazyLoadView from "@router/lazyload-view";
import routeError from "@router/route-error";
import store from '@store'

export default [
  // 外層產品系列 列表頁
  {
    path: '/product/list',
    name: 'product-list',
    component: () => import('@views/Product/Index'),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const { filterBrand = '', filterCategory = '', query = undefined, page = 1, orderBy= '' } = routeTo.query
          const statusMap =  [
            {
              alias: 'newest',
              query: {
                orderBy: 'created_at',
                order: 'desc' 
              }
            },
            {
              alias: 'oldest',
              query: {
                orderBy: 'created_at',
                order: 'asc' 
              }
            },
            {
              alias: 'asc',
              query: {
                orderBy: 'title',
                order: 'asc' 
              },
            },
            {
              alias: 'desc',
              query: {
                orderBy: 'title',
                order: 'desc' 
              }
            }
          ]
          const currentStatus = statusMap.filter((item) => {
            return item.alias === orderBy
          })
          const params = {
            brand_alias: filterBrand.length
              ? filterBrand.split(',')
              : undefined,
            product_category_alias: filterCategory.length
              ? filterCategory.split(',')
              : undefined,
            search: query,
            limit: 10,
            page,
            orderBy: currentStatus[0]? currentStatus[0].query.orderBy : undefined,
            order: currentStatus[0]? currentStatus[0].query.order : undefined,
          }
          const { items, pagination } = await store.dispatch('product/fetchList', params)
          routeTo.params.list = items;
          routeTo.params.pagination = pagination;

          next()
        } catch(error) {
          routeError(error, routeTo, next({ name: '404' }));
        }
      },
      alias: "list",
      title: '產品系列列表',
    },
    props: (route) => ({
      list: route.params.list,
      pagination: route.params.pagination,
    })
  },
  // 外層產品系列 內容頁
  {
    path: '/product/list/:productAlias',
    name: 'product-item',
    component: () => import('@views/Brand/Product/Item'),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const { productAlias } = routeTo.params
          const currentItem = await store.dispatch('product/fetchItem', productAlias)
          const [currentBrand] = await Promise.all([
            store.dispatch('brand/fetchBrand', {
              brandAlias: currentItem.brands[0].alias
            }),
          ])
          routeTo.params.currentBrand = currentBrand;
          routeTo.params.defaultValue = currentItem;
          // routeTo.params.breadcrumbTitle = currentItem.title;
          // routeTo.params.breadcrumbLevel3Title = store.state.brand.cachedBrand.title;

          next()
        } catch(error) {
          routeError(error, routeTo, next({ name: '404' }));
        }
      },
      alias: "list",
      title: '產品系列',
    },
    props: (route) => ({
      defaultValue: route.params.defaultValue,
      // currentBrand : route.params.currentBrand || {},
    })
  },
]
